export default __webpack_public_path__ + "static/media/game_2_m.a74183d4.png";